@if (!moduleOnly) {
<div class="background"></div>
<app-header></app-header>
<div class="content">
  <router-outlet></router-outlet>
  <app-cookie-banner></app-cookie-banner>
</div>
<app-footer></app-footer>
} @else {
<router-outlet></router-outlet>
}
